export const state = {
    dashboards: [],
    orderCounter: null,
    ticketsOpenCounter: null,
    feedbacksCounter: null
}
